export class ShippingSettingsModel {
  public option: string;
  public company: string;
}
